export default {
  'fieldEdit.header': 'Soru Özelliğini Düzenle',
  'fieldEdit.editSuccess': 'Soru özelliği başarıyla güncellendi!',
  'fieldEdit.deleteSuccess': 'Soru özelliği başarıyla silindi!',
  'fieldEdit.delete': 'Sil',
  'fieldEdit.invalidateUpdateOption':
    'Bu özellik seçeneği bir soru ile ilişkilendirildiği için işlem gerçekleştirilemez.',
};
